import { Modal, Button } from "flowbite-react";
import CustomThemeModal from '../CustomThemes/CustomThemeModal';
import { HiOutlineExclamationCircle } from "react-icons/hi";

type CustomYesNoModalPropType = {
    openModal: boolean,
    setOpenModal: (value: boolean) => void,
    message: string,
    yesAction: () => void
}

const CustomYesNoModal = ({openModal, setOpenModal, message, yesAction}: CustomYesNoModalPropType) => {

    return (
        <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup theme={CustomThemeModal}>              
            <Modal.Body>
                <div className="text-center">
                <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200 mt-3" />
                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                    {message}
                </h3>
                <div className="flex justify-center gap-4">
                    <Button color="failure" onClick={() => yesAction()}>
                    {"Yes, I'm sure"}
                    </Button>
                    <Button color="gray" onClick={() => setOpenModal(false)}>
                    No, cancel
                    </Button>
                </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CustomYesNoModal;
